"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 縣市
 *
 * @author Chris Tsai
 */
var County =
/*#__PURE__*/
function (_React$Component) {
  _inherits(County, _React$Component);

  function County(props) {
    var _this;

    _classCallCheck(this, County);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(County).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (e) {
      var value = e.target.value;
      var onChange = _this.props.onChange;

      if (typeof onChange == 'function') {
        onChange(value);
      }
    });

    return _this;
  }

  _createClass(County, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataOptions = _this$props.dataOptions,
          fieldName = _this$props.fieldName,
          countyClass = _this$props.countyClass,
          countyStyle = _this$props.countyStyle,
          value = _this$props.value,
          displayType = _this$props.displayType;
      var counties = !!dataOptions && dataOptions.map(function (op) {
        return React.createElement("option", {
          key: op,
          value: op
        }, op);
      });
      return React.createElement(React.Fragment, null, !!displayType && displayType === 'text' ? React.createElement("select", {
        name: fieldName,
        className: countyClass,
        style: countyStyle,
        onChange: this.handleChange,
        value: value
      }, counties) : React.createElement(React.Fragment, null, React.createElement("span", {
        className: countyClass,
        style: countyStyle,
        readOnly: true,
        disabled: true
      }, value), React.createElement("input", {
        type: "hidden",
        name: fieldName,
        value: value
      })));
    }
  }]);

  return County;
}(React.Component);

exports.default = County;
County.propTypes = {
  /**
   * 顯示樣式
   */
  displayType: _propTypes.default.oneOf(['text', 'display']),

  /**
   * 欄位名稱
   */
  fieldName: _propTypes.default.string.isRequired,

  /**
   * 欄位值
   */
  value: _propTypes.default.string,

  /**
   * onChange callback function
   */
  onChange: _propTypes.default.func,

  /**
   * dataOptions
   */
  dataOptions: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * class
   */
  countyClass: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object]),

  /**
   * style
   */
  countyStyle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object])
};